<template>
  <div>
    <header>
      <h4>Setting up your account.</h4>
      <vue-loading
        type="beat"
        color="#5028b7"
        :size="{ width: '50px', height: '50px' }"
      ></vue-loading>

            <br />
            <el-card shadow="never" class="mb20">
            <p class="large mb0">{{ currentRegistration.portalDomain.subdomain }}.talentsensus.com</p>
            </el-card>
            <p>This is where you will access your {{$t('lorganization')}} portal. Be sure to bookmark it once you’re inside.</p>
        </header>
    </div>
</template>

<script>
import { VueLoading } from "vue-loading-template";

export default {
  created() {
    this.submitRegistration();
  },
  components: { VueLoading },
  computed: {
    currentRegistration() {
      return this.$store.state.registration.current_registration;
    },
  },
  methods: {
    submitRegistration() {
      this.currentRegistration.isComplete = true;

      this.$store
        .dispatch("registration/store", this.currentRegistration)
        .then(() => {
          this.$router.app.$emit("navigateToNextStep");
        })
        .catch((res) => {
          this.currentRegistration.isComplete = false;
          this.currentRegistration.error = 'An error occurred whilst submitting your registration. Please try again later.';
          this.$router.app.$emit('navigateToPreviousStep');
        });
    },
  },
};
</script>

<style lang="scss"></style>
